import * as yup from "yup";

export enum CompanyFilterMode {
	ALL = "ALL",
	INCLUDE = "INCLUDE",
	EXCLUDE = "EXCLUDE",
}

export type FiltersProps = yup.InferType<typeof FiltersValidation>;

export const FiltersValidation = yup.object().shape({
	marketplace: yup.string(),
	companyId: yup.string(),
	companyIds: yup.array().of(yup.string()).default([]),
	//minThreshold: yup.string(),
	eventName: yup.string(),
	eventHeadliner: yup.string(),
	venue: yup.string(),
	startDate: yup.string(),
	endDate: yup.string(),
	dateRange: yup.string(),
	search: yup.string(),
	categoryId: yup.array().of(yup.string()).default([]),
	mpEventId: yup.string().optional(),
});

export const ExclusionValidation = yup.object().shape({
	exclusionName: yup.string(),
	exclusionLocation: yup.string(),
	venueExclusion: yup.string(),
	headlinerExclusion: yup.string(),
});

export const filtersEmptyValues: FiltersProps = {
	marketplace: "",
	companyId: "",
	companyIds: [],
	//minThreshold: "",
	eventName: "",
	eventHeadliner: "",
	venue: "",
	startDate: "",
	endDate: "",
	dateRange: "",
	search: "",
	categoryId: [],
	mpEventId: "",
};
